"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRuntime = getRuntime;
exports.setRuntime = setRuntime;
var _configurable = require("./configurable");
var _nreum = require("../../window/nreum");
var _runtime = require("../../constants/runtime");
var _env = require("../../constants/env.npm");
const readonly = {
  buildEnv: _env.BUILD_ENV,
  distMethod: _env.DIST_METHOD,
  version: _env.VERSION,
  originTime: _runtime.originTime
};
const model = {
  customTransaction: undefined,
  disabled: false,
  isolatedBacklog: false,
  loaderType: undefined,
  maxBytes: 30000,
  onerror: undefined,
  origin: '' + _runtime.globalScope.location,
  ptid: undefined,
  releaseIds: {},
  /** Agent-specific metadata found in the RUM call response. ex. entityGuid */
  appMetadata: {},
  session: undefined,
  denyList: undefined,
  harvestCount: 0,
  timeKeeper: undefined
};
const _cache = {};
function getRuntime(id) {
  if (!id) throw new Error('All runtime objects require an agent identifier!');
  if (!_cache[id]) throw new Error("Runtime for ".concat(id, " was never set"));
  return _cache[id];
}
function setRuntime(id, obj) {
  if (!id) throw new Error('All runtime objects require an agent identifier!');
  _cache[id] = {
    ...(0, _configurable.getModeledObject)(obj, model),
    ...readonly
  };
  const agentInst = (0, _nreum.getNREUMInitializedAgent)(id);
  if (agentInst) agentInst.runtime = _cache[id];
}